import styled from 'styled-components';

export const PublishButton = styled.div`
	margin-left: 4px;
	margin-right: 4px;
`;

export const Share = styled.div`
	margin-left: 4px;
	margin-right: 4px;
`;

export const Download = styled.div`
	margin-left: 4px;
	margin-right: 4px;
`;

export const ReadOnlyBanner = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 5px 14px;
	border-radius: 6px;
	font-size: 13px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[800]};
	background: ${({ theme }) => `${theme.blue[500]}14`};
	border: 1px solid ${({ theme }) => theme.blue[500]};
	white-space: nowrap;
	line-height: 1.4;
`;

export const ReadOnlyLink = styled.button`
	all: unset;
	color: ${({ theme }) => theme.blue[600]};
	text-decoration: underline;
	text-underline-offset: 2px;
	transition: color 0.15s ease;

	&:hover {
		color: ${({ theme }) => theme.blue[800]};
	}
`;
